import { Anchor, useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import { getCartItemSourceProps } from 'vivino-js/helpers/cartItemSources';
import JoinWithDelimiter from 'vivino-js/utilities/JoinWithDelimiter';

import styles from './wineFacts.scss';

const TRANSLATIONS = {
  delimiter: 'components.shared.wine_summary.delimiter',
};
const DELIMITER = TRANSLATIONS.delimiter;

const AnchorOrText = (value) => {
  if (value.url) {
    return (
      <Anchor
        className={styles.link}
        key={value.name}
        href={value.url}
        {...getCartItemSourceProps(value.cartItemSource)}
      >
        {value.name}
      </Anchor>
    );
  }
  return <span key={value.name}>{value.name}</span>;
};

const WineFact = ({ icon, headerLabel, values = [], delimiter = DELIMITER }) => {
  const { t } = useI18N();
  const Icon = icon;
  return (
    <tr data-testid="wineFactRow">
      <th>
        <div className={styles.headingWrapper}>
          <span className={styles.icon}>
            <Icon />
          </span>
          <span className={styles.headerLabel}>{headerLabel}</span>
        </div>
      </th>
      <td className={styles.fact}>{JoinWithDelimiter(values.map(AnchorOrText), t(delimiter))}</td>
    </tr>
  );
};

WineFact.propTypes = {
  icon: PropTypes.func.isRequired,
  headerLabel: PropTypes.any.isRequired,
  values: PropTypes.array.isRequired,
  delimiter: PropTypes.string,
};

export default WineFact;
